import { Color } from 'three'
import { ColorType } from './enums'

/**
 * The 12 `ColorType` colours, recovered from `GetEditorColor(ColorType)` in the
 * binary (see `tools/extract_palette.py`). They are sRGB, like every colour a
 * Unity material serialises.
 */
const RGB: Readonly<Record<ColorType, readonly [number, number, number]>> = {
  [ColorType.Black]: [0.12, 0.12, 0.12],
  [ColorType.Blue]: [0.0, 0.45, 1.0],
  [ColorType.Green]: [0.0, 0.8, 0.1],
  [ColorType.Orange]: [1.0, 0.58, 0.0],
  [ColorType.Purple]: [0.6, 0.0, 0.85],
  [ColorType.Red]: [0.9, 0.0, 0.0],
  [ColorType.Turquoise]: [0.0, 0.85, 0.85],
  [ColorType.Yellow]: [1.0, 0.88, 0.0],
  [ColorType.White]: [0.95, 0.95, 0.95],
  [ColorType.Grey]: [0.55, 0.55, 0.55],
  [ColorType.Brown]: [0.48, 0.24, 0.05],
  [ColorType.Pink]: [1.0, 0.3, 0.7],
  [ColorType.None]: [0.55, 0.55, 0.55],
}

const CACHE = new Map<ColorType, Color>()

/** Shared, immutable-by-convention `Color` for a `ColorType`. Do not mutate. */
export function colorOf(type: ColorType): Color {
  let c = CACHE.get(type)
  if (!c) {
    const [r, g, b] = RGB[type] ?? RGB[ColorType.None]
    // Authored the way Unity's colour picker shows them, i.e. sRGB — the same
    // reading every value out of a .mat needs. See toonMaterial.ts.
    c = new Color().setRGB(r, g, b, 'srgb')
    CACHE.set(type, c)
  }
  return c
}

export function colorNameOf(type: ColorType): string {
  return ColorType[type] ?? 'None'
}
